import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@mui/material';
import { trakrefBlue, trakrefDisabledBlue, focusColor } from '../../../color_utils';
import { trakrefFontFamilyBold } from '../../../utils';

const largeButtonTextStyle = {
    padding: '1.5% 0%',
    color: '#fff',
    fontSize: '16px',
    fontFamily: trakrefFontFamilyBold,
    letterSpacing: '1px',
};

const PrimaryButton = ({
    id,
    buttonText,
    onClick,
    disabled,
    fullWidth,
    useLargeButton,
    width,
    size,
    sx,
    StartIcon,
    EndIcon,
}) => {
    const primaryButtonStyle = {
        '&.MuiButton-root': {
            fontFamily: trakrefFontFamilyBold,
            color: '#FFF',
            backgroundColor: disabled ? trakrefDisabledBlue : trakrefBlue,
            letterSpacing: '1.2px',
            fontSize: { xs: '14px', md: '12px', lg: '14px' },
            padding: { xs: '6px 16px', md: '2px 8px', lg: '6px 16px' },
        },
        '&:focus': { outline: `3px solid ${focusColor}` }
    };

    if (useLargeButton) {
        return (
            <Button
                id={id}
                size="large"
                variant="contained"
                onClick={onClick}
                fullWidth={fullWidth}      
                sx={{ ...primaryButtonStyle, width: `${width}%`, height: '52px', ...sx }}
                disabled={disabled}
                startIcon={StartIcon && <StartIcon />}
                endIcon={EndIcon && <EndIcon />}
            >
                <Typography variant='h5' sx={largeButtonTextStyle}>
                    {buttonText}
                </Typography>
            </Button>
        );
    }

    return (
        <Button
            id={id}
            variant="contained"
            size={size}
            onClick={onClick}
            fullWidth={fullWidth}
            sx={{ ...primaryButtonStyle, width: `${width}%` }}
            startIcon={StartIcon && <StartIcon />}
            endIcon={EndIcon &&<EndIcon />}
            disabled={disabled}
        >
            {buttonText}
        </Button>
    );
};

PrimaryButton.propTypes = {
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    id: PropTypes.string,
    useLargeButton: PropTypes.bool,
    width: PropTypes.number,
    size: PropTypes.string,
    StartIcon: PropTypes.node,
    EndIcon: PropTypes.node,
    sx: PropTypes.object
};

PrimaryButton.defaultProps = {
    disabled: false,
    fullWidth: false,
    id: "",
    width: null,
    useLargeButton: false,
    size: "medium",
    StartIcon: null,
    EndIcon: null,
    sx: {}
};

export default PrimaryButton;
